import { IRequest } from '@r1-frontend/shared/types/IRequest';

import { IRequestDto } from './dto/RequestDto';

/**
 * Меню для сайта, разбитое по типам с дочерними типами.
 * Отличается от базового метода группировкой подпунктов
 *
 * {@link https://master.api-content.sandbox.d2c.r-one.io/docs/v2#/%D0%9C%D0%B5%D0%BD%D1%8E/get_v2_menu_by_variant_aliases Documentation}
 */
const menuByVariantAliases = (queryParams: IRequestDto): IRequest => ({
    uri: '/v2/menu/by-variant-aliases',
    method: 'GET',
    queryParams,
});

export type { IRequestDto };
export type { ResponseDto } from '@r1-frontend/api-domru/api-content/v2/menu/by-types/dto/ResponseDto';

export default menuByVariantAliases;
